import { render } from "./community-list.vue?vue&type=template&id=67a35199"
import script from "./community-list.vue?vue&type=script&lang=js"
export * from "./community-list.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__